import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommunicationsService } from '@app/_services';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { FormDataHelper } from '@app/_helpers';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgIf, NgFor } from '@angular/common';
import { IconComponent } from '../icon/icon.component';
import { FlexModule } from '@angular/flex-layout/flex';
import _ from 'lodash';
@Component({
    selector: 'app-ask-vendor',
    templateUrl: './ask-vendor.component.html',
    styleUrls: ['./ask-vendor.component.scss'],
    providers: [FormDataHelper],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, FlexModule, IconComponent, NgIf, MatButtonModule, MatIconModule, NgFor, TranslateModule]
})
export class AskVendorComponent implements OnInit {
    constructor(private fb: UntypedFormBuilder,
        private communicationService: CommunicationsService,
        public bsModalRef: BsModalRef,
        private toastr: ToastrService,
        private fd: FormDataHelper,
        public translate: TranslateService
    ) { }
    form = this.fb.group({
        msg: [null, [Validators.required]],
        images: []
    });
    user: any;
    companyId; //from initialState config
    product;
    files: any[] = [];
    file: any;
    url;
    message;


    ngOnInit(): void {
         if (this.product) {
            this.form.addControl('subject', new UntypedFormControl(this.product.name[this.translate.currentLang]));
            this.form.addControl('productId', new UntypedFormControl(this.product._id));
        }
        this.form.addControl('companyId', new UntypedFormControl(this.companyId));
        if (this.message) {
            this.form.get('msg')?.setValue(this.message);
        }
    }

    save() {
        if (this.form.invalid) {
            this.toastr.error('Fill In Required Fields');
            return
        }
         let message = new FormData();
        message = this.fd.ToFormData(this.form.value);
        this.communicationService.createCommunication(message).subscribe((response: any) => {
            if (response){
                this.bsModalRef.hide();
                this.toastr.success(response.msg);
            }
        }, (error) => {
            this.toastr.error(error.error?.msg)
        })
    }

    imagebObjectKey(imageObject) {
        return _.findKey(imageObject);
    }

    fileBrowseHandler(files) {
        this.prepareFilesList(files);
    }

    prepareFilesList(files: Array<any>) {
        for (const item of files) {
            this.url = null;
            const reader = new FileReader();
            reader.onload = () => {
                item.url = reader.result as string;
            }
            reader.readAsDataURL(item)
            this.files.push(item);
        }
        this.images.patchValue(Array.from(files));
    }

    deletePicture(index) {
        this.files.splice(index, 1);
        this.images.patchValue(this.files);
    }

    get images() {
        return this.form.get('images');
    }
}
